export default "__VITE_ASSET__DL35dh0F__"